import { View } from 'foundations-components/components/View';
import { Tag } from 'foundations-components/transitional/components/Tag';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const CurrentPlanTag = ({
  message = 'pricingPage.highlightedMerchCards.currentPlan'
}) => {
  return /*#__PURE__*/_jsx(View, {
    position: "absolute",
    insetBlockStart: "0",
    insetInlineStart: "0",
    children: /*#__PURE__*/_jsx(Tag, {
      use: "default",
      children: typeof message === 'string' ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: message
      }) : message
    })
  });
};
export default CurrentPlanTag;